"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeDeleteAsset = exports.conciergeUpdateAsset = exports.conciergeCreateAsset = exports.conciergeGetAssetTypes = exports.conciergeGetAssetsByPropertyId = exports.conciergeGetAssetById = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetAssetById = (0, graphql_tag_1.default) `
  ${fragments_graphql_1.ASSET_FIELDS}
  query conciergeGetAssetById($id: ID!) {
    conciergeGetAssetById(id: $id) {
      ...AssetFields
    }
  }
`;
exports.conciergeGetAssetsByPropertyId = (0, graphql_tag_1.default) `
  ${fragments_graphql_1.ASSET_FIELDS}
  query conciergeGetAssetsByPropertyId($propertyId: ID!) {
    conciergeGetAssetsByPropertyId(propertyId: $propertyId) {
      id
      ...AssetFields
    }
  }
`;
exports.conciergeGetAssetTypes = (0, graphql_tag_1.default) `
  query conciergeGetAssetTypes {
    conciergeGetAssetTypes {
      id
      name
      issueType {
        id
        name
      }
    }
  }
`;
exports.conciergeCreateAsset = (0, graphql_tag_1.default) `
  mutation conciergeCreateAsset($input: CreateAssetInput!) {
    conciergeCreateAsset(input: $input) {
      id
    }
  }
`;
exports.conciergeUpdateAsset = (0, graphql_tag_1.default) `
  mutation updateAsset($id: ID!, $input: UpdateAssetInput!) {
    conciergeUpdateAsset(id: $id, input: $input) {
      id
    }
  }
`;
exports.conciergeDeleteAsset = (0, graphql_tag_1.default) `
  mutation conciergeDeleteAsset($id: ID!) {
    conciergeDeleteAsset(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=asset.queries.graphql.js.map